export default class IssueUtils {
  public static getIssueString(label: string) {
    return encodeURIComponent(`Entry: ${label};`);
  }
}
